// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "segment-XlJyz";
var _3 = "flightInfo__date-fp5kN";
export { _1 as "__esModule", _2 as "segment", _3 as "flightInfo__date" }
export default { "__esModule": _1, "segment": _2, "flightInfo__date": _3 }
